import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined, TableOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import TabAmort from './TabAmort';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Typography } from '@mui/material';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import { useNavigate } from 'react-router-dom';
import HelpInfos from '../../../../HelpInfo';
import HelpData from "../../../../../Data/Help.json"
import Help from '../../../../../Types/Help';
import { DemandeMourabahaDto } from '../../../../../Models/DemandeMourabahaDto';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import { useAgence } from '../../../../../AgenceContext';
import { PrintTabamountMourabaha } from '../../../../../utilitaires/PrintTabamortMourabaha';

interface SelectData {
  value: string;
  label: string;
}

const DemandeMourabaha = () => {
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const authHeader = useAuthHeader();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [ajoutActve, setAjoutActif] = useState(false);
  const [modifActve, setModifActve] = useState(true);
  const [enregActve, setEnregActve] = useState(true);
  const [supActive, setSupActive] = useState(true);
  const [impActive, setImpActive] = useState(true);
  const [actuActive, setActActive] = useState(true);
  const [annulActive, setAnnulActive] = useState(true);
  const [consulActive, setConsulActive] = useState(false);
  const [sbmit, setSbmit] = useState('');
  const [DataGarantie, SetDataGarantie] = useState<SelectData[]>([]);
  const Branch = useAgence();

  const [garantiesTableau, setGarantiesTableau] = useState<DataTypeTable[]>([]);
  const [isGarantieOblig, setIsGarantieOblig] = useState(false);
  const [datatabamort, setdatatabamort] = useState<any[]>([]);
  const navigate = useNavigate();

  useEffect(() => { forceUpdate({}); }, []);

  function initialiazeButton() {
    setAjoutActif(false); setModifActve(true); setEnregActve(true); setSupActive(true); setImpActive(true); setActActive(true); setAnnulActive(true); setConsulActive(false);
  }

  const SetStart = () => {
    SetDataGarantie([]);
    setGarantiesTableau([]);
    setIsGarantieOblig(false);
    localStorage.removeItem(Data.LocalVariable.garantie);
    setSbmit('add');
    setAjoutActif(true);
    setEnregActve(false);
    setAnnulActive(false);
    setConsulActive(true);
    setdatatabamort([]);
    form.resetFields();
  };

  const SetEndStart = () => { SetStartForm(true); SeStartSearchG(false); };

  function handleAnulle() {
    let coduti = form.getFieldValue('CODUTI');
    form.resetFields();
    localStorage.clear();
    form.setFieldValue('CODUTI', coduti);
    initialiazeButton();
    SetDataGarantie([]);
    setGarantiesTableau([]);
    setIsGarantieOblig(false);
    setdatatabamort([]);
  }

  function cunsultButton() { setAnnulActive(false); setModifActve(false); setImpActive(false); }
  function modifButton() { setSbmit('update'); setModifActve(true); setAjoutActif(true); setEnregActve(false); setConsulActive(true); setImpActive(true); }

  function LoadGarantie() {
    SetDataGarantie([]);
    let dataGarantie: SelectData[] = [];
    try {
      let numcli = form.getFieldValue('NUMCLI');
      numcli += Data.LocalVariable.separator + 'CL';
      var config = { method: 'get', maxBodyLength: Infinity, url: Data.ApiUrl.GetGarantie, headers: { 'Content-Type': 'application/json', Authorization: authHeader(), CypherSearch: Crypter.encrypt(JSON.stringify(numcli)), }, };
      axios(config).then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            let filtered = datas.filter((item: any) => item.CdEtat === '02');
            if (filtered.length === 0) { localStorage.setItem('garanties_client', ''); } else {
              filtered.map((data: any) => { dataGarantie.push({ value: data.codgar + '|' + data.dispo, label: data.codgar + ' -> ' + formatNumber(parseFloat(data.VALGARANTI)) + ' XAF( disponible : ' + formatNumber(parseFloat(data.dispo + '')) + ' XAF)', }); });
              SetDataGarantie(dataGarantie);
              localStorage.setItem('garanties_client', Crypter.encrypt(JSON.stringify(filtered)));
            }
          }
        }
      }).catch((error) => { SweetAlert.fire({ title: 'Error', text: error, icon: 'error' }); });
    } catch (error) {
      SweetAlert.fire({ title: "Veillez sélectionnez le client donc vous voulez charger les garantie", icon: 'warning', });
      localStorage.setItem('garanties_client', '');
    }
  }

  const items: TabsProps['items'] = [
    { key: '1', label: (<span id="Tab"><UserOutlined />Demande</span>), children: (<Tab1 form={form} disabled={ajoutActve} LoadGarantie={LoadGarantie} setIsGarantieOblig={setIsGarantieOblig} />), },
    { key: '2', label: (<span id="Tab"><ContactsOutlined />Garanties</span>), children: (<Tab2 form={form} Datagarantie={DataGarantie} garantiesTableau={garantiesTableau} setGarantiesTableau={setGarantiesTableau} />), },
    { key: '3', label: (<span id="Tab"><UsergroupAddOutlined />Frais de service</span>), children: <Tab3 form={form} />, },
    { key: '4', label: (<span id="Tab"><TableOutlined />Tableau</span>), children: <TabAmort form={form} data={datatabamort} />, },
  ];

  const handleApercu = () => {
    const values = form.getFieldsValue(true);
    PrintTabamountMourabaha(
      {
        frais: values.FraisService ?? 0,
        NUMCLI: values.NUMCLI,
        NOMCLI: values.lib_NUMCLI ?? values.NOMCLI ?? '',
        NumeroDemande: values.NumeroDemande ?? '',
        CoutAchat: values.CoutAchatDemande,
        Marge: values.MargeMourabahaDem,
        NombreEch: values.NombreEch,
        DatePremEch: formatDate(values.DatePremEch),
      },
      {
        codAgce2: user.codage ?? '',
        libelle: Branch.agence?.LIBELLE ?? '',
        banque: Branch.agence?.BANQUE ?? '',
        teleph: Branch.agence?.TELEPH ?? '',
        numReg: Branch.agence?.NUMREG ?? '',
        licence: Branch.agence?.LICENCE ?? '',
        numCon: Branch.agence?.NUMCOM ?? '',
        bPoste: Branch.agence?.BPOSTE ?? '',
        ville: Branch.agence?.VILLE ?? '',
        nomUser: user.nomuti ?? '',
        libperiodicite: values.lib_Periodicite ?? values.Periodicite ?? '',
      },
    );
  };

  const onFinish = (val: any) => {
    const values = form.getFieldsValue(true);

    let Garanties = garantiesTableau.map((data: DataTypeTable) => ({ CodeGarantie: data.codgar, MontantCouvert: data.valCouvert }));

    if (isGarantieOblig) {
      SweetAlert.fire({ title: 'Garanties obligatoires', text: 'Ce type de Mourabaha exige au moins une garantie.', icon: 'warning' });
      return;
    }

      var DemandeMourabaha: DemandeMourabahaDto = { CODAGE: user.codage, DatePremEch: formatDate(values.DatePremEch), DateDemande: user.datjour, Numcli: values.NUMCLI, NOMCLI: values.lib_NUMCLI, Garanties: Garanties, ...values } as any;

      if (sbmit === 'add') {
        SweetAlert.fire({ title: 'Voulez-vous enregistrer la demande de financment Mourabaha du client : ' + values.lib_NUMCLI + ' à hauteur du montant ?', showCancelButton: true, color: 'green', confirmButtonText: 'Yes', confirmButtonColor: 'green', cancelButtonColor: 'darkred', cancelButtonText: 'No', showLoaderOnConfirm: true, icon: 'question', }).then((res) => {
          if (res.isConfirmed) {
            try {
              setLoading(true); setIsSubmit(true); 
           
              (DemandeMourabaha as any).UtilDemande = user.coduti; (DemandeMourabaha as any).CodeUti = user.coduti;
              let data = Crypter.encrypt(JSON.stringify(DemandeMourabaha));
              let config = { method: 'post', maxBodyLength: Infinity, url: Data.ApiUrl.DemandeMourabaha, headers: { Authorization: authHeader(), 'Content-Type': 'application/json', }, data: data, };
              axios.request(config).then((response) => { setLoading(false); if (response.data) { const res = JSON.parse(Crypter.decrypt(response.data)).Value; if (res.StatutCode == 200) { initialiazeButton(); form.resetFields(); setGarantiesTableau([]); setImpActive(false); SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' }); } else { SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' }); } } }).catch((error) => { setLoading(false); console.log(error); SweetAlert.fire({ title: error, icon: 'error' }); });
            } catch (error) { SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: 'error', }); }
          }
        });
      }

      if (sbmit === 'update') {
        SweetAlert.fire({ title: 'Voulez-vous modifier la demande de financement ' + values.NumeroDemande + ' ?', showCancelButton: true, color: 'green', confirmButtonText: 'Yes', confirmButtonColor: 'green', cancelButtonColor: 'darkred', cancelButtonText: 'No', showLoaderOnConfirm: true, icon: 'question', }).then((res) => {
          if (res.isConfirmed) {
            try {
              setLoading(true); setIsSubmit(true); (DemandeMourabaha as any).CodeUti = user.coduti;
              let data = Crypter.encrypt(JSON.stringify(DemandeMourabaha));
              let config = { method: 'put', maxBodyLength: Infinity, url: Data.ApiUrl.UpdateFindMourabaha, headers: { Authorization: authHeader(), 'Content-Type': 'application/json', }, data: data, };
              axios.request(config).then((response) => { setLoading(false); if (response.data) { const res = JSON.parse(Crypter.decrypt(response.data)).Value; if (res.StatutCode == 200) { initialiazeButton(); form.resetFields(); setGarantiesTableau([]); setImpActive(false); SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' }); } else { SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' }); } } }).catch((error) => { setLoading(false); console.log(error); SweetAlert.fire({ title: error, icon: 'error' }); });
            } catch (error) { SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: 'error', }); }
          }
        });
      }
   //} else { SweetAlert.fire({ title: "Vous devez d'abord sélectionner les garanties de prêt avant d'enregistrer", icon: 'warning', }); }
  };

  const onFinishFailed = async (errorInfo: any) => { var errors: any = []; errorInfo.errorFields.map((error: any) => { errors.push(error.name + ''); }); SweetAlert.fire({ title: 'Veuillez remplir tous les champs obligatoires', text: errors.toString().replaceAll(',', ' - '), icon: 'warning', confirmButtonText: 'OK', }); };

  function consult() {
    let data = Crypter.encrypt(form.getFieldValue('NumeroDemande'));
    let numdemande = form.getFieldValue('NumeroDemande');
    let dataction = Crypter.encrypt('READ_DEMANDE');
    if (data.length != 0) {
      form.setFieldValue('garantie', ''); form.setFieldValue('avaliste', ''); initialiazeButton(); setLoading(true); form.resetFields(); form.setFieldValue('NumeroDemande', numdemande);
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ReadFiancementMourabaha,
        headers: {
          CypherNumeroDemandeMourabaha: data,
          CypherAction: dataction,
          Authorization: authHeader(),
          'Content-Type': 'application/json',
        },
      };
      axios.request(config).then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          // alert(JSON.stringify(res))
          if (res.StatutCode == 200) {
            form.setFieldsValue(res.Result.Table1[0]);
            form.setFieldValue('DatePremEch', ReformatDate(res.Result.Table1[0].DatePremEch));
            form.setFieldValue('lib_NUMCLI', res.Result.Table1[0].NOMCLI); localStorage.clear();
            const garantiesRetournees: DataTypeTable[] = [];
            if (res.Result.Table2) {
              res.Result.Table2.map((data: any, index: number) => {

                garantiesRetournees.push({ ...data, valCouvert: data.MontantCouvert })
              })
            } setGarantiesTableau(garantiesRetournees);
            const newData: any[] = [];
            if (res.Result.Table3) {
              res.Result.Table3.map((item: any) => {
                newData.push({
                  ...item,
                  CapitalInitial: formatNumber(item.CapitalInitial),
                  Armotissement: formatNumber(item.Armotissement),
                  PartMargeHT: formatNumber(item.PartMargeHT),
                  PartTVA: formatNumber(item.PartTVA),
                  Annuite: formatNumber(item.Annuite),
                  CapitalRestant: formatNumber(item.CapitalRestant),
                  SoldeRestantTTC: formatNumber(item.SoldeRestantTTC),
                  DateEcheance: item.DateEcheance ? new Date(item.DateEcheance.substring(0, 10)).toLocaleDateString('fr') : '',
                });
              });
            }
            setdatatabamort(newData);
            localStorage.setItem(Data.LocalVariable.garantie, JSON.stringify(garantiesRetournees));
            consultTypeMourabaha();
            initialiazeButton();
            cunsultButton();
          } else {
            localStorage.removeItem(Data.LocalVariable.reset);
            SweetAlert.fire({ title: res.Message, icon: 'warning' });
          }
        } setLoading(false);
      }).catch((error) => { localStorage.removeItem(Data.LocalVariable.reset); setLoading(false); console.log(error); SweetAlert.fire({ title: error, icon: 'error' }); });
    }
  }

  function modif() { modifButton(); }

  function consultTypeMourabaha() {
    if (form.getFieldValue('CodeMourabaha') == null) {
      SweetAlert.fire({ title: 'Svp renseigner le Code du type de Mourabaha ', icon: 'warning' });
    } else {
      let data = Crypter.encrypt(form.getFieldValue('CodeMourabaha'));
      if (data.length != 0) {
        setLoading(true);
        let config = {
          method: 'get', maxBodyLength: Infinity, url: Data.ApiUrl.ReadParamsMourabaha,
          headers: { CypherCodeMourabaha: data, Authorization: authHeader(), 'Content-Type': 'application/json' },
        };
        axios.request(config).then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
             const params = res.Result.Table1[0];
             setIsGarantieOblig(params.IsGarantieObligatoir === true || params.IsGarantieObligatoir === 'true');
             // const frais = res.Result.Table3?.reduce((total: number, x: any) => total + Number(x.MONFIX || 0), 0) || 0;
              form.setFieldValue('CodeFrais', res.Result.Table3?.map((x: any) => x.CODOPE) || []);
              form.setFieldValue("MontantFrais", params.MontantFrais);
            } else {
              SweetAlert.fire({ title: 'Warning', text: res.Message, icon: 'warning' });
            }
          }
          setLoading(false);
        }).catch((error) => { setLoading(false); console.log(error); SweetAlert.fire({ title: 'Error', text: error, icon: 'error' }); });
      }
    }
  }

  return (
    <div className="tab">
      <Typography align="center" className="formTitle"><b>{window.location.pathname}</b></Typography>
      <Spin spinning={loading} size="large" style={{ color: 'green' }}>
        <Form disabled={!ajoutActve} autoComplete="off" preserve labelAlign="left" form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className="bG">
            <legend><Typography color={'darkgreen'}>Actions</Typography></legend>
            <Form.Item shouldUpdate className="bouttong">
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size="large" className="bt_add" disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block>Consulter</Button>
                <Button size="large" className="bt_add" disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block>Ajouter</Button>
                <Button size="large" className="bt_add" disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block>Modifier</Button>
                <Button size="large" className="bt_add" disabled={enregActve} type="ghost" htmlType="submit" block>Enregistrer</Button>
                {/* <Button size="large" className="bt_add" onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>Supprimer</Button> */}
                <Button size="large" onClick={handleApercu} className="bt_add" disabled={impActive} type="ghost" htmlType="button" block>Aperçu</Button>
                <Button size="large" className="bt_add" disabled={actuActive} type="ghost" htmlType="button" block>Actualiser</Button>
                <Button size="large" disabled={annulActive} onClick={handleAnulle} className="bt_add" type="ghost" htmlType="reset" block>Annuler</Button>
              </Space>
            </Form.Item>
            <HelpInfos helpInfo={HelpData.Pret.DemandeDePret as Help} />
          </div>
          <div className="clientP"><div><Tabs size="large" type="card" defaultActiveKey="1" items={items} /></div></div>
        </Form>
      </Spin>
    </div>
  );
};

export default DemandeMourabaha;
